import { keyBy } from 'lodash';

export const CHAT_AGENT_ACTION_TYPE = {
    NAVIGATE: 'NAVIGATE',
    FORM_ACTION: 'FORM_ACTION',
    SET_RECOMMENDED_DATA: 'SET_RECOMMENDED_DATA',
    EDIT_GRID_CELL: 'EDIT_GRID_CELL',
    ABORT: 'ABORT',
    CONNECT: 'CONNECT',
    DISCONNECT: 'DISCONNECT',
    OPEN_CHAT: 'OPEN_CHAT',
    CLOSE_CHAT: 'CLOSE_CHAT',
    MESSAGE: 'MESSAGE',
    DOWNLOAD_FILE: 'DOWNLOAD_FILE',
    FORM_WIZARD_STEP: 'FORM_WIZARD_STEP',
    CHANGE_RENDER_MODE: 'CHANGE_RENDER_MODE',
    FIX_BUTTON_CONNECT: 'FIX_BUTTON_CONNECT',
    METHOD: 'METHOD',
    ANALYTICS_EVENT: 'ANALYTICS_EVENT',
    SET_DYNAMIC_REPORT_DATA: 'SET_DYNAMIC_REPORT_DATA',
};

export const CHAT_AGENT_MESSAGE_SOURCE = {
    USER: 'USER',
    AGENT: 'AGENT',
};

export const MANUAL_GA_EVENTS = keyBy([CHAT_AGENT_ACTION_TYPE.OPEN_CHAT, CHAT_AGENT_ACTION_TYPE.CLOSE_CHAT]);
